export default __webpack_public_path__ + "static/media/cooling.0076dc54.png";